// extracted by mini-css-extract-plugin
export default {"downloadLink":"DownloadLink_downloadLink__A8jwJ","downloadLinkIcon":"DownloadLink_downloadLinkIcon__xj7vn"};